import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingAndLocationsTitle: {
        id: "renewal.wizard.commercial.TWIA.BuildingLoc",
        defaultMessage: "Buildings & Locations"
    },
    buildingAndLocationsCardTitle: {
        id: "renewal.wizard.commercial.TWIA.Add buildings and locations by entering their details.",
        defaultMessage: "Add buildings and locations by entering their details."
    },
    addBuilding: {
        id: "renewal.wizard.commercial.TWIA.Add Building",
        defaultMessage: "Add Building"
    },
    cancelButton: {
        id: "renewal.wizard.commercial.TWIA.Cancel",
        defaultMessage: "Cancel"
    },
    nextButton: {
        id: "renewal.wizard.commercial.TWIA.Next",
        defaultMessage: "Next"
    },
    anotherButton: {
        id: "renewal.wizard.commercial.TWIA.anotherBuilding",
        defaultMessage: "Add Another Building"
    },
    doneButton: {
        id: "renewal.wizard.commercial.TWIA.Done",
        defaultMessage: "Done"
    },
    locationStep: {
        id: "renewal.wizard.commercial.TWIA.Location",
        defaultMessage: "Location"
    },
    buildingStep: {
        id: "renewal.wizard.commercial.TWIA.BuildingStep",
        defaultMessage: "Building"
    },
    constructionStep: {
        id: "renewal.wizard.commercial.TWIA.Construction",
        defaultMessage: "Construction"
    },
    coveragesStep: {
        id: "renewal.wizard.commercial.TWIA.Coverages",
        defaultMessage: "Coverages"
    },
    additionalInterestsStep: {
        id: "renewal.wizard.commercial.TWIA.Additional Interests",
        defaultMessage: "Additional Interests"
    },
    cancelModalTitle: {
        id: "renewal.wizard.commercial.TWIA.Cancel Adding Building?",
        defaultMessage: "Cancel Adding Building?"
    },
    cancelModalDescription: {
        id: "renewal.wizard.commercial.TWIA.The information you have already provided about this building will be lost",
        defaultMessage: "The information you have already provided about this building will be lost. Are you sure you want to cancel?"
    },
    previousModalTitle: {
        id: "renewal.wizard.commercial.TWIA.Leave Page?",
        defaultMessage: "Leave Page?"
    },
    previousModalDescription: {
        id: "renewal.wizard.commercial.TWIA.Changes made to the building will be lost. ",
        defaultMessage: "Changes made to the building will be lost."
    },
    editLocation: {
        id: "renewal.wizard.commercial.editLocation",
        defaultMessage: "Edit Location"
    },
    editBuilding: {
        id: "renewal.wizard.commercial.editBuilding",
        defaultMessage: "Edit Building"
    },
    editConstruction: {
        id: "renewal.wizard.commercial.editConstruction",
        defaultMessage: "Edit Construction"
    },
    editCoverages: {
        id: "renewal.wizard.commercial.editCoverages",
        defaultMessage: "Edit Coverages"
    },
    editAddlInt: {
        id: "renewal.wizard.commercial.editAddlInt",
        defaultMessage: "Edit Additional Interest"
    },
    BCCovLimitAndBCRCV: {
        id: "twia.renewal.cp.views.building.BCCovLimitAndBCRCV information banner",
        defaultMessage: "The amount of insurance on Building Coverage {text} the minimum requirement for replacement cost coverage."
    },
    BPCovLimitAndBPRCV: {
        id: "twia.renewal.cp.views.building.BPCovLimitAndBPRCV information banner",
        defaultMessage: "The amount of insurance on Business Personal Property Coverage {text} the minimum requirement for replacement cost coverage."
    }
})